/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface ReleaseUpgradePath { 
    release_type: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    /**
     * Upgrade from version.
     */
    from: string;
    /**
     * Upgrade to version.
     */
    to: string;
    /**
     * True if upgrade allowed from version to the target version.
     */
    allowed?: boolean;
}
export namespace ReleaseUpgradePath {
}


